module.exports = __webpack_public_path__ + "static/design03-5d1042a868b7a4b27bd0ddf7c25b0ebc.png";